import { createContext, useContext } from "react";
export const LayoutProducerContext = createContext(undefined);
const NOOP = { setPanes: () => { }, setCommands: () => { } };
/** @internal The producer handle, or a no-op if there's no `<ArtisAppProvider>` above. */
export const useLayoutProducer = () => useContext(LayoutProducerContext) ?? NOOP;
//# sourceMappingURL=layoutProducer.js.map